import React, { useState } from 'react';
import { Search, MapPin, Truck, CheckCircle, XCircle, Package, Sparkles, AlertCircle, RefreshCw } from 'lucide-react';
import { useMyContext } from '../../../../context/MyContext';

import NavBar from '../../../../component/b2c/navBar/navBar';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import { Base_Url, getpincode } from '../../../../config/config';
import { toast } from 'react-toastify';

const PincodeService = () => {
  const [pincode, setPincode] = useState('');
  const [isChecking, setIsChecking] = useState(false);
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const [pincodeData, setPincodeData] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const handleCheck = async () => {
    setIsChecking(true);
    setShowResults(false);
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const urlgetPincode = `${Base_Url}${getpincode}?pincode=${pincode}`;

    try {
      const response = await fetch(urlgetPincode, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();

      if (data && data.status === "SUCCESS") {
        setPincodeData(data.data);
        setIsChecking(false);
        setShowResults(true);
      } else if (data && data.message === "Unauthorized access - Invalid token") {
        toast.error(data.message + " Please login Again");
        setIsChecking(false);
      } else if (data && data.status === "FAIL") {
        toast.error("Something Went Wrong Please Try Again With Another Pincode");
        setIsChecking(false);
      } else {
        toast.error("Failed to fetch city and state data");
        setIsChecking(false);
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);
      toast.error("Error fetching pincode data");
      setIsChecking(false);
    }
  };

  const hasResults = showResults && pincodeData && pincodeData.length > 0;
  const noResults = showResults && (!pincodeData || pincodeData.length === 0);

  // Sample pincodes for quick test
  const samplePincodes = ['110001', '400001', '560001', '700001'];

  // Cosmetic-only maps for partner accent colors (icons/handlers untouched)
  const partnerTheme = {
    Delhivery: { icon: '🚚', dot: 'bg-red-400' },
    Shiprocket: { icon: '📦', dot: 'bg-amber-400' },
    Ecom: { icon: '🏪', dot: 'bg-sky-400' },
    Ekart: { icon: '🛵', dot: 'bg-yellow-400' },
    XpressBees: { icon: '🐝', dot: 'bg-orange-400' },
  };
 const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.5)]";
  return (
    <div className="h-screen flex flex-col overflow-hidden relative bg-[#F7F5FF] dark:bg-[#0a0918] transition-colors duration-300">

      {/* Ambient background field */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -left-20 h-[26rem] w-[26rem] rounded-full bg-violet-300/30 dark:bg-indigo-600/20 blur-[100px]" />
        <div className="absolute top-1/3 -right-24 h-96 w-96 rounded-full bg-fuchsia-200/30 dark:bg-fuchsia-600/10 blur-[100px]" />
        <div className="absolute bottom-0 left-1/3 h-72 w-72 rounded-full bg-indigo-200/20 dark:bg-violet-500/10 blur-[100px]" />
      </div>

      <NavBar />
      <div className="flex flex-1 overflow-hidden relative z-10">
                             <div
            className={`
              ${isToggleSidebar ? "w-64" : "w-[72px]"}
              m-3
              rounded-3xl
              ${glass}
              overflow-hidden
              transition-all
              duration-300
              ease-in-out
            `}
          >
            <Sidebar />
          </div>

        <div className="flex-1 p-4 md:p-6 w-full overflow-hidden flex flex-col">

          {/* Header */}
          <div className="flex-shrink-0 mb-5">
            <div className="flex items-center gap-3">
              <div className="relative w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-br from-violet-600 to-fuchsia-500 shadow-[0_4px_16px_rgba(139,92,246,0.4)]">
                <Package size={16} className="text-white" strokeWidth={2.25} />
              </div>
              <div>
                <h1 className="text-base font-bold text-[#1E1B2E] dark:text-white tracking-tight leading-tight">Pincode Service Checker</h1>
                <p className="text-[10px] text-[#6B6480] dark:text-indigo-200/40">Scan delivery coverage for any pincode, instantly</p>
              </div>
            </div>
          </div>

          {/* Main Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-[380px_1fr] gap-5 flex-1 min-h-0">

            {/* Left - Search Card */}
            <div className="rounded-2xl overflow-hidden flex flex-col shrink-0 bg-white/80 dark:bg-white/[0.04] border border-violet-100 dark:border-white/10 shadow-[0_10px_40px_rgba(109,40,217,0.08)] dark:shadow-[0_10px_40px_rgba(99,102,241,0.12)] backdrop-blur-xl">

              {/* Radar / scan visual — reflects the "scanning coverage" idea */}
              <div className="relative h-28 flex items-center justify-center border-b border-violet-100 dark:border-white/10 bg-gradient-to-b from-violet-50 to-white/0 dark:from-indigo-500/[0.06] dark:to-transparent overflow-hidden">
                <div className="relative w-14 h-14 flex items-center justify-center">
                  {isChecking && (
                    <>
                      <span className="absolute inset-0 rounded-full bg-violet-400/40 dark:bg-indigo-400/30 animate-ping" />
                      <span className="absolute -inset-3 rounded-full border border-violet-300/60 dark:border-indigo-400/30 animate-ping [animation-delay:150ms]" />
                      <span className="absolute -inset-6 rounded-full border border-violet-200/50 dark:border-indigo-400/20 animate-ping [animation-delay:300ms]" />
                    </>
                  )}
                  <div className={`relative w-11 h-11 rounded-full flex items-center justify-center bg-gradient-to-br from-violet-600 to-fuchsia-500 shadow-[0_4px_20px_rgba(139,92,246,0.5)] transition-transform ${isChecking ? 'scale-95' : ''}`}>
                    <MapPin size={19} className="text-white" strokeWidth={2.25} />
                  </div>
                </div>
              </div>

              <div className="px-5 pt-4 pb-1">
                <h2 className="text-[11px] font-bold text-[#1E1B2E] dark:text-indigo-100 tracking-tight">Check a pincode</h2>
                <p className="text-[9px] text-[#6B6480] dark:text-indigo-200/40 mt-0.5">Enter 6 digits to see who delivers there</p>
              </div>

              <div className="p-4 pt-3 flex flex-col gap-3.5">
                <div>
                  <div className="relative">
                    <input
                      id="pincode"
                      type="text"
                      maxLength="6"
                      inputMode="numeric"
                      autoComplete="off"
                      placeholder="e.g. 110001"
                      value={pincode}
                      onChange={(e) => setPincode(e.target.value.replace(/\D/g, ''))}
                      className="w-full pl-4 pr-9 py-2.5 text-[13px] font-mono tracking-widest rounded-xl border border-violet-200 dark:border-white/10 bg-violet-50/60 dark:bg-black/30 text-[#1E1B2E] dark:text-white placeholder:text-violet-300 dark:placeholder:text-indigo-200/25 placeholder:tracking-normal placeholder:font-sans focus:outline-none focus:ring-2 focus:ring-violet-400 dark:focus:ring-indigo-400/60 focus:border-transparent transition-all"
                    />
                    {pincode.length === 6 && (
                      <CheckCircle size={15} className="absolute right-3 top-1/2 -translate-y-1/2 text-emerald-500 dark:text-emerald-400" />
                    )}
                  </div>
                  {pincode.length > 0 && pincode.length < 6 && (
                    <p className="text-[8px] text-violet-400 dark:text-indigo-200/40 mt-1 ml-1">{6 - pincode.length} more digit{6 - pincode.length > 1 ? 's' : ''} to go</p>
                  )}
                </div>

                <button
                  onClick={handleCheck}
                  disabled={isChecking || pincode.length !== 6}
                  className={`w-full py-2.5 text-[11px] font-semibold rounded-xl transition-all flex items-center justify-center gap-2 ${
                    isChecking || pincode.length !== 6
                      ? 'bg-violet-50 dark:bg-white/[0.04] text-violet-300 dark:text-indigo-200/25 cursor-not-allowed'
                      : 'bg-gradient-to-r from-violet-600 to-fuchsia-500 text-white hover:brightness-110 active:scale-[0.98] shadow-[0_6px_20px_rgba(139,92,246,0.4)] dark:shadow-[0_6px_20px_rgba(99,102,241,0.5)]'
                  }`}
                >
                  {isChecking ? (
                    <>
                      <RefreshCw size={13} className="animate-spin" />
                      Scanning coverage...
                    </>
                  ) : (
                    <>
                      <Search size={13} />
                      Check Availability
                    </>
                  )}
                </button>

                <div className="flex items-center gap-1.5 flex-wrap pt-0.5">
                  <span className="text-[8px] text-violet-400 dark:text-indigo-200/40 font-medium">Quick test</span>
                  {samplePincodes.map((code) => (
                    <button
                      key={code}
                      onClick={() => setPincode(code)}
                      className="px-2 py-0.5 text-[8px] font-mono font-medium border border-violet-200 dark:border-white/10 rounded-md hover:bg-violet-100 dark:hover:bg-white/10 hover:border-violet-300 dark:hover:border-white/20 transition-colors text-violet-500 dark:text-indigo-200/60"
                    >
                      {code}
                    </button>
                  ))}
                </div>

                <div className="grid grid-cols-2 gap-2 pt-2 mt-1 border-t border-violet-100 dark:border-white/10">
                  <div className="flex items-center gap-2 p-2 pt-3">
                    <Truck size={13} className="text-violet-500 dark:text-indigo-300 shrink-0" />
                    <span className="text-[8px] font-medium text-[#6B6480] dark:text-indigo-200/60">5 courier partners</span>
                  </div>
                  <div className="flex items-center gap-2 p-2 pt-3">
                    <Sparkles size={13} className="text-fuchsia-500 dark:text-purple-300 shrink-0" />
                    <span className="text-[8px] font-medium text-[#6B6480] dark:text-indigo-200/60">Real-time result</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right - Results Panel */}
            <div className="rounded-2xl overflow-hidden flex flex-col bg-white/80 dark:bg-white/[0.04] border border-violet-100 dark:border-white/10 shadow-[0_10px_40px_rgba(109,40,217,0.08)] dark:shadow-[0_10px_40px_rgba(99,102,241,0.12)] backdrop-blur-xl">

              {/* Results Header */}
              <div className="px-5 py-3.5 border-b border-violet-100 dark:border-white/10 shrink-0 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className={`w-2 h-2 rounded-full ${hasResults ? 'bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.7)]' : noResults ? 'bg-rose-500 shadow-[0_0_8px_rgba(244,63,94,0.7)]' : 'bg-violet-300 dark:bg-white/20'}`}></div>
                  <span className="text-[10.5px] font-semibold text-[#1E1B2E] dark:text-indigo-100">
                    {hasResults ? `${pincodeData.length} result${pincodeData.length > 1 ? 's' : ''} found` : noResults ? 'No coverage found' : 'Ready to check'}
                  </span>
                </div>
                {hasResults && (
                  <span className="text-[8px] font-mono text-violet-400 dark:text-indigo-200/40">#{pincode}</span>
                )}
              </div>

              {/* Results Content */}
              <div className="flex-1 overflow-y-auto custom-scrollbar p-3">
                {hasResults && (
                  <div className="space-y-2">
                    {pincodeData.map((shipment, index) => {
                      const partners = [];
                      if (shipment.delhivery === "1") partners.push('Delhivery');
                      if (shipment.shiprocket === "1") partners.push('Shiprocket');
                      if (shipment.ecom === "1") partners.push('Ecom');
                      if (shipment.ekart === "1") partners.push('Ekart');
                      if (shipment.xpressbees === "1") partners.push('XpressBees');

                      return (
                        <div key={index} className="group relative pl-4 pr-3 py-3 rounded-xl border border-violet-100 dark:border-white/5 bg-white dark:bg-white/[0.02] hover:shadow-[0_4px_20px_rgba(139,92,246,0.12)] dark:hover:bg-white/[0.05] hover:-translate-y-0.5 transition-all">
                          <span className={`absolute left-0 top-2 bottom-2 w-1 rounded-full ${partners.length > 0 ? 'bg-gradient-to-b from-violet-500 to-fuchsia-400' : 'bg-rose-300'}`} />
                          <div className="flex items-center justify-between gap-3">
                            <div className="flex items-center gap-4">
                              <div className="text-center leading-none">
                                <div className="text-sm font-bold text-[#1E1B2E] dark:text-white font-mono tracking-wider">{shipment.pincode}</div>
                                <div className="text-[7.5px] text-violet-400 dark:text-indigo-200/40 uppercase tracking-wider mt-1">Pincode</div>
                              </div>
                              <div className="w-px h-8 bg-violet-100 dark:bg-white/10"></div>
                              <div>
                                <div className="text-[11.5px] font-semibold text-[#1E1B2E] dark:text-indigo-100">{shipment.city}</div>
                                <div className="text-[9px] text-[#6B6480] dark:text-indigo-200/40">{shipment.state}</div>
                              </div>
                            </div>
                            <div className="flex flex-wrap justify-end gap-1 max-w-[45%]">
                              {partners.length > 0 ? (
                                partners.map((name, idx) => (
                                  <span key={idx} className="px-2 py-1 rounded-full text-[8px] font-medium bg-violet-50 dark:bg-white/[0.06] border border-violet-100 dark:border-white/10 text-[#4C1D95] dark:text-indigo-200 flex items-center gap-1">
                                    <span className={`w-1.5 h-1.5 rounded-full ${partnerTheme[name]?.dot || 'bg-violet-400'}`} />
                                    {name}
                                  </span>
                                ))
                              ) : (
                                <span className="px-2 py-1 rounded-full text-[8px] font-medium bg-rose-50 dark:bg-rose-500/10 border border-rose-100 dark:border-rose-400/20 text-rose-500 dark:text-rose-300 flex items-center gap-1">
                                  <XCircle size={10} /> No Partner
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {noResults && (
                  <div className="flex flex-col items-center justify-center h-full text-center p-6">
                    <div className="relative w-16 h-16 rounded-full border-2 border-rose-200 dark:border-rose-400/20 bg-rose-50 dark:bg-rose-500/10 flex items-center justify-center mb-3">
                      <AlertCircle size={26} className="text-rose-500 dark:text-rose-300" />
                    </div>
                    <h3 className="text-sm font-bold text-[#1E1B2E] dark:text-white">No coverage here — yet</h3>
                    <p className="text-[10px] text-[#6B6480] dark:text-indigo-200/50 max-w-sm mt-1">
                      None of our courier partners currently deliver to <span className="font-mono font-bold text-rose-500 dark:text-rose-300">{pincode}</span>.
                    </p>
                    <button
                      onClick={() => { setPincode(''); setShowResults(false); }}
                      className="mt-4 px-4 py-1.5 text-[9px] font-semibold border border-violet-200 dark:border-white/10 rounded-lg hover:bg-violet-50 dark:hover:bg-white/10 transition-colors text-violet-600 dark:text-indigo-200/70"
                    >
                      Try another pincode
                    </button>
                  </div>
                )}

                {!showResults && (
                  <div className="flex flex-col items-center justify-center h-full text-center p-6">
                    <div className="relative w-16 h-16 rounded-full border-2 border-dashed border-violet-200 dark:border-indigo-400/20 flex items-center justify-center mb-3">
                      <MapPin size={26} className="text-violet-300 dark:text-indigo-300/60" />
                    </div>
                    <h3 className="text-sm font-semibold text-[#1E1B2E] dark:text-indigo-100">Nothing scanned yet</h3>
                    <p className="text-[10px] text-[#6B6480] dark:text-indigo-200/40 mt-1">Enter a 6-digit pincode on the left to see coverage</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PincodeService;